import { Slide } from '@/components/core/Slide';
import audioFile from './34-eva-leaves.mp3';

// const autoNextDuration = 12000;
const transcript = `
  Ok dan... Ik trek me maar eens even terug Jonathan, ik ben elders nodig.

  Zou jij tot slot willen afsluiten met agentic AI, en wat dat is? Geef maar een seintje als het afgelopen is.
`;

// Jonathan: Natuurlijk EVA, dank je wel voor je inzichten. Ik zal het publiek uitleggen wat agentic AI is
// en waarom het zo belangrijk is voor de toekomst van technische bedrijven.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      // autoNext={autoNextDuration}
      visualizer="full"
      networkBackground="full"
      transition="fade"
    >
      <div></div>
    </Slide>
  );
};
